import { LOCATION_PROVINCE } from '../../routes';
import customAxios from '../../customAxios';

async function deleteProvince(_id: string) {
  try {
    return (await customAxios.delete(`${LOCATION_PROVINCE}/${_id}`)).data;
  } catch (error: any) {
    console.error({LOCATION_PROVINCE: error});
  }
}

export default deleteProvince;
